import createDataContext from './createDataContext';
import * as actions from './actions/systemInfoActions';
import { reducer, initialState } from './reducers/systemInfoReducer';

export const { Context: SystemInfoContext, Provider } = createDataContext(
  reducer,
  actions,
  initialState
);
